import {
  VALIDATE_BEGIN,
  VALIDATE_SUCCESS,
  VALIDATE_FAILURE,
  PASS_VALIDATE_EMAIL,
} from "../actions/validateactions";

const initialState = {
  loading: false,
  validateError: null,
  email: null,
};

export function validateReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case PASS_VALIDATE_EMAIL:
      nextState.email = action.email;
      return nextState;
    case VALIDATE_BEGIN:
      nextState.loading = true;
      return nextState;
    case VALIDATE_SUCCESS:
      nextState.loading = false;
      return nextState;
    case VALIDATE_FAILURE:
      nextState.loading = false;
      //nextState.validateError = action.error;
      return nextState;
    default:
      return state;
  }
}
